// Extract {{1}}, {{2}}, ... placeholders from a body text and return them
// as a sorted, de-duplicated list of placeholder keys ("1", "2", ...).
// Matches the helper used in the admin portal so the placeholder order
// here aligns with the example.body_text order recorded at template create.
export const extractPlaceholders = (text) => {
  if (!text) return [];
  const matches = text.match(/\{\{(\d+)\}\}/g) || [];
  const keys = matches.map((m) => m.slice(2, -2));
  return [...new Set(keys)].sort((a, b) => Number(a) - Number(b));
};

// Pulls the BODY component text out of an API template row's components[].
export const getBodyText = (template) => {
  const components = Array.isArray(template?.components)
    ? template.components
    : [];
  const body = components.find((c) => c.type === "BODY");
  return body?.text || "";
};

// Build the Meta runtime components payload for /send-template using the
// values the user typed into the Fill in Values inputs. We only handle BODY
// variables here — header/buttons with variables aren't exposed in the UI.
//
// Returns the body needed by sendTemplate:
//   { templateId, components: [{ type: "body", parameters: [{type:"text",text}, ...] }] }
// When the template has no placeholders, the components key is omitted so
// Meta receives a clean "no parameters" template send.
export const buildRuntimeBody = (template, samples = {}) => {
  const body = { templateId: template.id };
  const placeholders = extractPlaceholders(getBodyText(template));
  if (placeholders.length === 0) return body;
  body.components = [
    {
      type: "body",
      parameters: placeholders.map((key) => ({
        type: "text",
        text: samples[key] || "",
      })),
    },
  ];
  return body;
};
